import { ChevronDown, Check, Columns3 } from "lucide-react"
import { Menu, MenuTrigger, MenuPopup, MenuItem } from "@/components/ui/menu"
import { PIPELINE_PRESETS, PIPELINE_COLUMNS } from "@/constants/deal.constants"

interface PipelinePresetsProps {
  activePreset: string
  onPresetChange: (presetId: string) => void
}

export function PipelinePresets({ activePreset, onPresetChange }: PipelinePresetsProps) {
  const currentPreset = PIPELINE_PRESETS.find((p) => p.id === activePreset)

  return (
    <Menu>
      <MenuTrigger className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-muted/50 border border-border text-sm text-foreground hover:bg-muted">
        <Columns3 className="size-4 text-muted-foreground" aria-hidden="true" />
        <span>{currentPreset?.name ?? "Custom"}</span>
        <ChevronDown className="size-4 text-muted-foreground" aria-hidden="true" />
      </MenuTrigger>
      <MenuPopup align="start" sideOffset={4} className="min-w-[200px]">
        {PIPELINE_PRESETS.map((preset) => (
          <MenuItem
            key={preset.id}
            onClick={() => onPresetChange(preset.id)}
            className="flex items-center justify-between"
          >
            <div>
              <span className="font-medium">{preset.name}</span>
              <p className="text-xs text-muted-foreground mt-0.5">
                {preset.columns.map((colId) => PIPELINE_COLUMNS.find((c) => c.id === colId)?.title).join(" -> ")}
              </p>
            </div>
            {activePreset === preset.id && <Check className="size-4 text-primary shrink-0" aria-hidden="true" />}
          </MenuItem>
        ))}
      </MenuPopup>
    </Menu>
  )
}
